(function () {
    angular.module('tmx-app').directive("chipSelect", chipSelect);

    function chipSelect() {
        return {
            scope: {
                name: "@",
                placeholder: "@",
                required: "@",
                form: "=",
                disabled: "=",
                noCache: "=",
                model:"=",
                data:"=",
                searchText:"=",
                selectedItem:"=",
                removeChip:"&",
                addChip:'&'
            },
            restrict: 'E',
            templateUrl: 'common/directives/chipselect/chipselect.html',
            controller: chipSelectCtrl,
            controllerAs: 'selectCtrl'
        };

    }

    function chipSelectCtrl($scope) {

        var selectCtrl=this;
        selectCtrl.searchText=null;

        selectCtrl.scope=$scope;
        selectCtrl.transformChip=function(chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
            return { name: chip, type: 'new' }
        }
        selectCtrl.createFilterFor= function (query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                return (item.VisibleValue.toLowerCase().indexOf(lowercaseQuery) >= 0);

            };
        }
        selectCtrl.querySearch= function(query) {
            if(angular.isDefined(selectCtrl.scope.data)) {
                var results = query ?selectCtrl.scope.data.filter(selectCtrl.createFilterFor(query)) : selectCtrl.scope.data;
                return results;

            }
        }
        selectCtrl.onChange= function($chip) {
            selectCtrl.scope.removeChip( {$chip : $chip});
        }
        selectCtrl.onChangeAdd= function($chip) {
            selectCtrl.scope.addChip( {$chip : $chip});
        }
    }

})();